<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1>
          <ng-container *ngIf="contest;else contestLoading">{{contest.name}}:
            &nbsp;
            <ng-container *ngIf="regions && regionId">{{regions.get(regionId)}}</ng-container>
          </ng-container>
          <ng-template #contestLoading>
            <mat-spinner color="primary" diameter="40"></mat-spinner>
          </ng-template>
        </h1>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <mat-accordion *ngIf="!inProgress" class="filters-panel">
        <mat-expansion-panel [expanded]="false" #expansionPanel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span *ngIf="filteredSchoolStats.length;else noSchoolsSelected">
                <ng-container
                  i18n="Exam region schools results|Selected schools count title@@exam-region-schools-result-selected-schools-count-title">
                  Selected schools:
                </ng-container>
                &nbsp;
                {{filteredSchoolStats.length}}
              </span>
              <ng-template #noSchoolsSelected>
                <ng-container
                  i18n="Exam region schools results|Select schools filter title@@exam-region-schools-result-select-schools-filter-title">
                  Select schools from the list
                </ng-container>
              </ng-template>
            </mat-panel-title>
            <mat-panel-description class="school-filter-description">
              <mat-checkbox *ngIf="expansionPanel.expanded"
                            class="select-all-checkbox"
                            [checked]="allSelected"
                            color="primary"
                            (change)="selectAllSchools($event.checked)"
                            (click)="$event.stopPropagation();">
                <ng-container i18n="General|Select all term@@general-select-all-term">select all</ng-container>
              </mat-checkbox>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-selection-list *ngIf="schools && schools.size" class="no-focus school-filter"
                              (selectionChange)="handleSchoolSelection($event)">
            <ng-container *ngFor="let region of schoolRegions">
              <div mat-subheader>
                <mat-checkbox class="region-select-checkbox"
                              color="primary"
                              [checked]="isRegionSelected(region)"
                              (change)="selectRegionSchools($event.checked, region)">
                  {{region}}
                </mat-checkbox>
              </div>

              <mat-list-option *ngFor="let data of schools.get(region)"
                               class="list-option mat-small no-focus"
                               checkboxPosition="before"
                               [value]="data"
                               [selected]="data.selected">
                <div class="school-item">{{data.school.short_name || data.school.name}} ({{data.school.address}})</div>
              </mat-list-option>
            </ng-container>
          </mat-selection-list>
        </mat-expansion-panel>
      </mat-accordion>

      <div *ngIf="!inProgress && schoolStats && schoolStats.length > 0;else noStatsInfo">
        <exam-region-schools-result-table [examStats]="filteredSchoolStats"
                                          [mobileView]="mobileView"></exam-region-schools-result-table>
      </div>

      <ng-template #noStatsInfo>
        <app-no-content *ngIf="!inProgress && contest"
                        [compact]="true"
                        title="No statistical data available at the moment"
                        i18n-title="Stats|User exam card stats missing title@@stats-user-exam-card-stats-missing-title"
                        details="Stats will be populated after students participate in the contest"
                        i18n-details="Stats|Users exam stats missing details@@stats-users-exam-stats-missing-details"></app-no-content>
      </ng-template>

      <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center progress"></mat-spinner>
    </div>
  </div>
</permission-checker>
